/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { computed } from 'vue';

var DefaultAlign = {
  vertical: ["left", "right"],
  horizontal: ["top", "bottom"]
};
var TimelineInjectKey = Symbol("timeLineProvide");
var DEFAULT_PROVIDER = computed(function () {
  return {
    theme: "default",
    reverse: false,
    itemsStatus: [],
    layout: "horizontal",
    renderAlign: "left",
    mode: "alternate"
  };
});

export { DEFAULT_PROVIDER, DefaultAlign, TimelineInjectKey };
//# sourceMappingURL=hooks.mjs.map
